import { LisaAndAgreementType, ServiceType } from '../enums.js'
import { calculationResponseSchema, SubscriptionDTO } from '../types.js'
import { formatLisaAndNumber } from './maths.js'
import { getPlanDurationInMonths } from './utils.js'

export default abstract class CommonLisaAndInterface {
    static getBaseUrl = () => process.env.APP_LISAAND_API_BASE_URL
    static getVendor = () => process.env.APP_LISAAND_API_VENDOR

    static getProductPrices = async (subscription: SubscriptionDTO) => {
        if (!subscription.products || !subscription.currency) {
            return []
        }

        const totalGenericDiscount = (subscription.products || []).reduce((acc, product) => {
            if (product.discount) {
                acc = acc + product.discount
            }

            if (product.services) {
                acc =
                    acc +
                    product.services.reduce((serviceAcc, service) => {
                        if (service.discount && service.service?.type !== ServiceType.TRADE_IN) {
                            serviceAcc = serviceAcc + service.discount
                        }

                        return serviceAcc
                    }, 0)
            }

            return acc
        }, 0)

        const plans = subscription.products[0].possiblePlans?.map((plan) => {
            return {
                variation_type: plan.plan?.code === 'FLEX' ? LisaAndAgreementType.FLEXIBLE : LisaAndAgreementType.FIXED,
                stock_monthly_price: formatLisaAndNumber(plan.priceWithVat),
                duration: getPlanDurationInMonths(
                    plan.plan?.durationInMonths || 12,
                    plan.plan?.code,
                    subscription.country?.code,
                ),
            }
        })

        const tradeInDiscount = subscription.nonQueryableMeta?.estimatedTradeInValue || 0

        return await CommonLisaAndInterface.getLisaAndPrices(
            subscription.currency.code,
            totalGenericDiscount,
            tradeInDiscount,
            plans,
        )
    }

    static getLisaAndPrices = async (
        currencyCode: string,
        totalDiscount: number,
        tradeInDiscount: number,
        plans?: Array<{
            variation_type: LisaAndAgreementType.FIXED | LisaAndAgreementType.FLEXIBLE
            stock_monthly_price: number
            duration: number
        }>,
    ) => {
        const response = await fetch(
            `${CommonLisaAndInterface.getBaseUrl()}/payment-engine/api/v1/price-calculation/${CommonLisaAndInterface.getVendor()}/price`,
            {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    total_discount: formatLisaAndNumber(totalDiscount),
                    currency: currencyCode,
                    total_subsidy_amount: formatLisaAndNumber(tradeInDiscount),
                    price_variations: plans,
                    version: 'v3',
                }),
            },
        )

        const responseJson = await response.json()

        return calculationResponseSchema.parse(responseJson)
    }
}
